<script lang="ts">
  import Button from "../shared/inputs/button/Button.svelte";

  export let options: {
    isCardFocused: boolean;
    onPay: () => void;
    currencySymbol?: string;
    feeToApply?: number;
  };
  export let isPaymentDisabled: boolean;
  export let isLoading: boolean;
  export let totalToPay: string;

  const MINIMUM_AMOUNT = 0.5;
  const isTotalTooLow = +totalToPay < MINIMUM_AMOUNT;

  let { isCardFocused, onPay, currencySymbol = "$" } = options;
</script>

<div class="crtw-text-base crtw-mb-1.5">Credit card details</div>
<div
  id="cpui-card-element"
  class="crtw-border crtw-border-gray-300 crtw-rounded crtw-px-2.5 crtw-py-4 crtw-mb-2.5 crtw-w-full"
  style={isCardFocused ? "border-color: #121e2b" : ""}
/>
<!-- Used to display Element errors. -->
<div id="card-errors" role="alert" />
<Button
  text={isTotalTooLow
    ? `Minimum card payment: ${currencySymbol}${MINIMUM_AMOUNT}`
    : `Pay ${currencySymbol}${totalToPay}`}
  onClick={onPay}
  disabled={isPaymentDisabled || isTotalTooLow}
  bind:isLoading
/>
{#if options.feeToApply}
  <span class="crtw-text-xs crtw-text-stone-200"
    >Fee of {options.feeToApply * 100}% is automatically added.</span
  >
{/if}
